// eslint-disable react/jsx-props-no-spreading

import {useCallback, useEffect, useMemo, useState} from "react";

// @mui material components
import {Grid, Tooltip, Typography, Box, Button, FormControl, InputLabel, Select, MenuItem, IconButton, Icon, Dialog, DialogTitle, DialogContent, DialogActions} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import data from "../../dashboard/components/Projects/data";
import { formatTransactionStatus } from "../../../utils";
import useApi from "../../../components/Utils/api";
import toast from "react-hot-toast";
import {DatePicker} from "rsuite";
import { afterToday } from "rsuite/cjs/DateRangePicker/disabledDateUtils";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarDensitySelector, GridToolbarExport
} from '@mui/x-data-grid';
import {styled} from "@mui/material/styles";
const getTooltipMessage = (status) => {
    switch (status) {
        case "SETTLEMENT_INITIATED":
            return "Settlement has been initiated.";
        case "PENDING":
            return "Settlement is pending.";
        case "FAILED":
            return "Settlement failed.";
        case "SETTLED":
            return "Settlement is done.";
        default:
            return "Unknown status.";
    }
};
function CardSettlementSummary() {
  const { cardSettlementSummaryTableColumns } = data();
  const [summary, setSummary] = useState([]);
  const [lastMonthDateRange, setLastMonthDateRange] = useState(new Date());
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [settlementRoutes, setSettlementRoutes] = useState([]);
  const [selectedRouteId, setSelectedRouteId] = useState('');
  const [txDialogOpen, setTxDialogOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const openTransactions = (row) => {
    setSelectedRow(row);
    setTxDialogOpen(true);
  };
  const transactionColumns = [
    { headerName: "Reference", field: "referenceId", flex: 1, minWidth: 160, align: "left" },
    { headerName: "Date", field: "transactionDate", flex: 1, minWidth: 170, align: "left" },
    { headerName: "Amount", field: "amount", flex: 1, minWidth: 120, align: "left" },
    { headerName: "Currency", field: "currency", flex: 1, minWidth: 90, align: "left" },
    { headerName: "Status", field: "status", flex: 1, minWidth: 120, align: "left", valueGetter: (value) => formatTransactionStatus(value) },
    { headerName: "Settlement Status", field: "settlementStatus", flex: 1, minWidth: 160, align: "left" },
    { headerName: "Batch No", field: "batchNo", flex: 1, minWidth: 140, align: "left", valueGetter: (value) => value || 'N/A' },
  ];
  const handleSettleAll = () => {
    const merchantsToSettle = rowSelectionModel.map((merchantRow) => {
      if (summary[merchantRow].settlementStatus === 'PENDING' && summary[merchantRow].settlementAllowed) return {
        merchantId : summary[merchantRow].merchantId,
        settlementAmount : summary[merchantRow].settlementAmount
      };
    })
    const data = {
        settlementSummary : merchantsToSettle,
        date : formatDate(lastMonthDateRange),
        currency: summary[rowSelectionModel[0]].currency,
        paymentMethod: summary[rowSelectionModel[0]].source,
        ...(selectedRouteId ? { settlementRouteId: selectedRouteId } : {})
    }
    api.post("settlements", data)
        .then((response) => {
          if (response.data?.data?.status === "INITIATED") {
            toast.success("Settlement initiated successfully. Batch id is "+response.data.data.batchId, { id: 'SuccessfullyInitated' });
            if(lastMonthDateRange !== null){
                getCardSettlementSummary(lastMonthDateRange, selectedRouteId);
                setRowSelectionModel([]);
            }
          } else {
              console.log(response.data);
              if (response.data?.error?.message) {
                  toast.error(response.data?.error?.message, {id: "NotSuccessfullyInitated"});
                  return;
              }
            toast.error("Something wrong happened, couldn't inititate settlement.", {id: "NotSuccessfullyInitated"});
          }
        })
        .catch((error) => {
            if (error.response && error.response.status === 500) {
                toast.error(error.response.data.error.message, { id: "FiveHundred" });
                return;
            }
          console.log("error", error)
        })
  };
  // const [fromDate, setFromDate]= useState(lastMonthDateRange[0]);
  // const [toDate, setToDate ]= useState(lastMonthDateRange[1]);
  const api = useApi();
    const formatDate = (date) => {
        const inputDate = new Date(date);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${month}/${day}/${year}`;
    };
  const getCardSettlementSummary = (lastMonthDateRange, routeId) => {
    if(lastMonthDateRange == null) return;
    setLastMonthDateRange(lastMonthDateRange);
    const data = {
      date : formatDate(lastMonthDateRange),
      ...(routeId ? { settlementRouteId: routeId } : {})
    }
    api.post("settlements/summary", data)
        .then((response) => {
          if (response.data.data.settlementSummary.length > 0) {
            const modifiedData = response.data.data.settlementSummary.map((item, index) => {
              // const action = (
              //     <MDBox display="flex" alignItems="center" lineHeight={1}>
              //       <MDButton color="info" variant="info">Settle</MDButton>
              //     </MDBox>
              // );
              // return { ...item, action, id: index };
              return { ...item, id: index, beneficiaryAccount: item.beneficiaryAccounts && item.beneficiaryAccounts.length > 0 ? item.beneficiaryAccounts[0].accountNumber : 'N/A'};
            });
            setSummary(modifiedData);
          } else {
            toast.error("No Record Found", { id: "NoRecordFound" });
            setSummary([])
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            // Check if a toast with the same message is already on the screen
            toast.error("You do not have permission to perform this action.", { id: "PermissionError" });
            return;
          }
          // Check if a toast with the same message is already on the screen
          toast.error("No Record Found", { id: "NoRecordFound" });
        });
  }
    const handleRowSelectionChange = useCallback((newSelection) => {
        setRowSelectionModel(newSelection);
    }, []);
  function CustomToolbar() {
    return (
        <GridToolbarContainer>
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
          <GridToolbarExport />
          {rowSelectionModel.length > 0 ? <Button
              onClick={handleSettleAll}
          >
            Settle All
          </Button> : <></>}
        </GridToolbarContainer>
    );
  }
    const StyledDataGrid = styled(DataGrid)({
        '&': {
            color: '#7b809a !important',
            fontSize: '0.875rem !important',
        },
        '& .MuiDataGrid-virtualScroller': {
            overflowX: 'scroll !important',
        },
        '& .MuiDataGrid-cellContent': {
            paddingLeft: '2px',
        },
        '& .MuiDataGrid-row.greyed': { backgroundColor: '#f5f5f5', color: '#9e9e9e' },
    });
    const renderCellWithTooltip = (params) => {
        const { row } = params;
        const isPending = row.settlementStatus !== 'PENDING';
        const isAllowed = !row.settlementAllowed;

        let tooltipMessage = '';
        if (isPending) {
            switch (row.settlementStatus) {
                case "SETTLEMENT_INITIATED":
                    tooltipMessage = "Settlement has been initiated.";
                    break;
                case "FAILED":
                    tooltipMessage = "Settlement failed.";
                    break;
                case "SETTLED":
                    tooltipMessage = "Settlement is done.";
                    break;
                default:
                    tooltipMessage = "Settlement is pending.";
                    break;
            }
        } else if (isAllowed) {
            tooltipMessage = 'Settlement is not allowed due to unavailability of relevant currency settlement account.';
        }

        return (
            <Tooltip
                title={
                    <Typography sx={{ fontSize: 12 }}>
                        {tooltipMessage}
                    </Typography>
                }
                disableHoverListener={!tooltipMessage}
            >
                <span>{params.value}</span>
            </Tooltip>
        );
    };

    const columnsWithTooltip = useMemo(() => {
    const mapped = cardSettlementSummaryTableColumns.map((col) => {
      if (col.field === 'batchNo') {
        return {
          ...col,
          renderCell: (params) => {
            if (params.row.batchNo && params.row.settlementStatus !== "PENDING") {
              return (
                <Box 
                  display="flex" 
                  alignItems="center" 
                  sx={{ 
                    gap: 0.5,
                    height: '100%',
                    justifyContent: 'flex-start',
                    paddingLeft: '2px',
                    '& .MuiButton-root': {
                      minWidth: 'auto',
                      padding: '4px 8px',
                      fontSize: '0.75rem',
                      backgroundColor: 'transparent',
                      color: 'info.main',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }
                  }}
                >
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontWeight: 500,
                      color: 'text.secondary'
                    }}
                  >
                    {params.row.batchNo}
                  </Typography>
                  <Button 
                    variant="text"
                    size="small"
                    onClick={() => {
                      api.get(`settlements/${params.row.batchNo}`)
                        .then((response) => {
                          toast.success(response.data.data.settlementStatusResponses[0].statusDescription, { id: "SUCCESS" });
                        })
                        .catch((error) => {
                          if (error.response) {
                            const status = error.response.status;
                            if (status === 400) {
                              toast(error.response.data.error.message, { id: "BAD_REQUEST" });
                            } else if (status === 403) {
                              toast.error("You do not have permission to perform this action.", { id: "PermissionError" });
                            } else if (status === 500) {
                              toast(error.response.data.error.message, { id: "SETTLEMENT_FAILED" });
                            }
                          } else {
                            toast.error("No Record Found", { id: "NoRecordFound" });
                          }
                        });
                    }}
                  >
                    Check
                  </Button>
                </Box>
              );
            }
            return null;
          }
        };
      }
      if (col.renderCell) {
        return col;
      }
      return {
        ...col,
        renderCell: renderCellWithTooltip,
      };
    });
    return [...mapped, {
      headerName: "Transactions",
      field: "__transactions",
      sortable: false,
      filterable: false,
      disableExport: true,
      minWidth: 130,
      align: "left",
      renderCell: (params) => (
        <Tooltip title={(params.row.transactions && params.row.transactions.length > 0) ? "View transactions" : "No transactions"}>
          <span>
            <IconButton
              size="small"
              color="info"
              disabled={!params.row.transactions || params.row.transactions.length === 0}
              onClick={() => openTransactions(params.row)}
            >
              <Icon fontSize="small">receipt_long</Icon>
            </IconButton>
          </span>
        </Tooltip>
      ),
    }];
  }, [cardSettlementSummaryTableColumns, api]);
    useEffect(() => {
        api.get("settlement-routes")
            .then((res) => {
                const routes = res.data || [];
                setSettlementRoutes(routes);
                // Open the page on the default settlement route's records.
                // Fall back to all routes only if no route is flagged as default.
                const defaultRoute = routes.find((r) => r.isDefault);
                if (defaultRoute) {
                    setSelectedRouteId(defaultRoute.id);
                    getCardSettlementSummary(lastMonthDateRange, defaultRoute.id);
                } else {
                    getCardSettlementSummary(lastMonthDateRange, '');
                }
            })
            .catch(() => {
                // Routes unavailable — fall back to the all-routes summary so the page still loads.
                getCardSettlementSummary(lastMonthDateRange, '');
            });
    },[]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12} sx={{ width: "100%" }}>
            <Grid item xs={12} md={12} lg={12}>
              <MDBox mb={3} display="flex" justifyContent="center" alignItems="center" gap={2}>
                <DatePicker
                    oneTap
                    disabledDate={afterToday()}
                    onChange={(date) => getCardSettlementSummary(date, selectedRouteId)}
                    format="yyyy-MM-dd"
                    value={lastMonthDateRange ? lastMonthDateRange : ''}
                />
                <FormControl size="small">
                  <InputLabel id="settlement-route-label">Settlement Route</InputLabel>
                  <Select
                    labelId="settlement-route-label"
                    label="Settlement Route"
                    value={selectedRouteId}
                    style={{ height: '35px', minWidth: '200px' }}
                    onChange={(e) => {
                      const routeId = e.target.value;
                      setSelectedRouteId(routeId);
                      getCardSettlementSummary(lastMonthDateRange, routeId);
                    }}
                  >
                    <MenuItem value="">All Routes</MenuItem>
                    {settlementRoutes.map((route) => (
                      <MenuItem key={route.id} value={route.id}>{route.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
            </Grid>
            {/*<DataTable*/}
            {/*  table={{ columns : cardSettlementSummaryTableColumns, rows : summary }}*/}
            {/*  showTotalEntries={true}*/}
            {/*  isSorted={true}*/}
            {/*  noEndBorder*/}
            {/*  entriesPerPage={true}*/}
            {/*  canSearch={true}*/}
            {/*/>*/}
            {/*<TableContainer sx={{ boxShadow: "none", width: '100%' }}>*/}
            <StyledDataGrid
                autoHeight
                style={{ backgroundColor: 'white',  }}
                rows={summary}
                columns={columnsWithTooltip}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10, 25, 50, 100]}
                checkboxSelection
                getRowClassName={(params) => (params.row.settlementStatus !== 'PENDING' || !params.row.settlementAllowed ? 'greyed' : '')}
                isRowSelectable={(params) => params.row.settlementStatus === 'PENDING' && params.row.settlementAllowed}
                disableRowSelectionOnClick
                onRowSelectionModelChange={handleRowSelectionChange}
                rowSelectionModel={rowSelectionModel}
                indeterminateCheckboxAction="select"
                slots={{
                    toolbar: CustomToolbar,
                }}
                slotProps={{
                    toolbar: {
                        csvOptions: {
                            filename: 'settlement-summary',
                            delimiter: ',',
                            utf8WithBom: true,
                        },
                        printOptions: {
                            hideFooter: true,
                            hideToolbar: true,
                            includeCheckboxes: true,
                        }
                    }
                }}
            />
            {/*</TableContainer>*/}
          </Grid>
        </Grid>
      </MDBox>
      <Dialog open={txDialogOpen} onClose={() => setTxDialogOpen(false)} maxWidth="lg" fullWidth>
        <DialogTitle>
          Transactions{selectedRow ? ` — ${selectedRow.merchantName} (${selectedRow.currency})` : ''}
        </DialogTitle>
        <DialogContent dividers>
          <StyledDataGrid
            autoHeight
            density="compact"
            style={{ backgroundColor: 'white' }}
            rows={(selectedRow?.transactions || []).map((t, i) => ({ ...t, id: t.id || i }))}
            columns={transactionColumns}
            initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTxDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Footer />
    </DashboardLayout>
  );
}

export default CardSettlementSummary;
